module.exports = __webpack_public_path__ + "img/WechatIMG264.5a6dfab3.jpeg";